<template>
  <div>
    <!-- 新增备注 -->
    <h2 class="column-title">Notes</h2>
    <div>
      <el-row>
        <el-col :span="12" :offset="6">
          <el-input
            :disabled="getDisabled() || getAuthShow()"
            :placeholder="$t('view.placeholder')"
            suffix-icon="el-icon-notebook-1"
            v-model="notes"
          >
          </el-input>
        </el-col>
        <el-col :span="1" style="margin-left: 5px;">
          <el-button type="primary" :disabled="getDisabled() || getAuthShow()" @click="addNotes" >{{$t('action.complete')}}</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 默认备注信息 -->
     <div style="margin-top: 20px;height: 20px;"></div>
    <div style="width: 1200px;margin:auto;font-size: 14px;">
      <p v-for="(item, idx) in data" :key="idx">
        <el-checkbox v-model="isShowNoteChecked" v-if="showPrintCheckbox(item)" >{{ item.replace("（可选打印）",'') }}</el-checkbox>
        <template v-else>
          {{ item }}
        </template>
      
    </p>
    </div>
    <div v-if="showENAditionalText()">
     <el-row>
      <el-checkbox v-model="aditional.note1.checked" @change="aditionalNoteCheckedChange()">{{aditional.note1.text}}</el-checkbox><br/>
     </el-row>
      <el-checkbox v-model="aditional.note2.checked" @change="aditionalNoteCheckedChange()">{{aditional.note2.text}}</el-checkbox><br/>
      <el-checkbox v-model="aditional.note3.checked" @change="aditionalNoteCheckedChange()">{{aditional.note3.text}}</el-checkbox><br/>
    </div>
    <div v-if="showCNAditionalText()">
     <el-row>
      <el-checkbox v-model="aditional.cnNote1.checked" @change="aditionalNoteCheckedChange()">{{aditional.cnNote1.text}}</el-checkbox><br/>
     </el-row>
    </div>

    <!-- 新增备注信息⬆ -->
    <div style="margin-top: 20px; margin-bottom: 20px; display: flex; flex-direction: column; align-items: center;">
      <el-row
        v-for="(item, idx) in this.notesArray"
        :key="idx"
        style="margin-top: 10px; width: 100%; justify-content: center; display: flex;"
      >
        <el-col :span="12" style="display: flex; justify-content: center;">
          <div style="text-align: center; margin-top: 3px;"><b>{{item}}</b></div>
        </el-col>
        <el-col :span="1" style="display: flex; align-items: center; justify-content: center;">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="mini"
            @click="deleteNotes(idx)"
            :disabled="viewDisabled || getAuthShow()"
          ></el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import * as defaultData from "@/views/NEW/module/template/DefaultData";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from '../../spec/config/eventBus';
import base from "@/common/base.js";
export default {
  name: "ZDSpecNote", 
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  inject: [
    "getCurrentDataMethod",
    "getNotesConfigMethod",
    "setNotesConfigMethod",
    "addCustomNoteMethod",
    "removeCustomNoteMethod",
    "setAdditionalNotesConfigMethod"
  ],
  computed: {
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    zdComponentState() {
      let val = "";
      if(this.zdId.indexOf("spec-note")!=-1){
        val = this.zdGetComponentState('tab1_notes_id_input_4');
      }else{
        val = this.zdGetComponentState('tab1_notes_id_input_0');
      }
      return val;
    },
    zdItem() {
      return this.zdComponentState;
    },
    viewDisabled(){
      // 使用inject获取数据，替代localStorage
      const currentData = this.getCurrentDataMethod();
      if(currentData.pageStatus == 'Detail'){
        return false;
      }
      return this.zdItem.disabled
    },
    zdFormattedValue: {
      get() {
        return this.zdGetComponentState(this.zdId); 
      },
      set(value) {
        this.zdUpdateComponent({
          id: 'tab1_notes_id_input_4',
          field: "value",
          value: value,
        }); 
        this.zdUpdateComponent({
          id: 'tab1_notes_id_input_5',
          field: "value",
          value: value,
        }); 
      },
    },
  },
  data() {
    return {
      data: [],
      notes: "",
      notesArray:[],
      selectProductType:"CSFMU-B",
      isShowNoteChecked:true,
      aditional:{
        note1:{
          checked:true,
          text:"Manufacturing Site: Shanghai Tianyuan Plant Products Company, Ltd. No.18 Hexiang Rd, Baihe Town, Qingpu District, Shanghai.",
        },
        note2:{
          checked:true,
          text:"The above listed product is non-irradiated product.",
        },
        note3:{
          checked:true,
          text:"Disclaimer: This product is intended only for animal use and is not intended for human consumption.",
        },
        cnNote1:{
          checked:true,
          text:"产品含抗氧化化合物，可能会随着时间推移颜色变深但不影响使用效果。",
        }
      }
    };
  },
  watch: {
    selectProductType(newValue) {
      this.data = this.getContentByType(newValue);
    },
    notes(newValue) {
      console.info('notes==newValue:',newValue)
    }
  },
  created() {
    const currentData = this.getCurrentDataMethod();
    EventBus.$on("eventupdateNotes",()=>{
      console.info("eventupdateNotes111:")
      this.data = this.getContentByType(currentData.itemCode);
    })
    
    // console.info('00zdItem:',this.zdItem)
    if(this.zdItem.value){
      this.notesArray = this.zdItem.value.toString().split('@$');
    }else if(currentData.notes){
      this.notesArray = currentData.notes;
    }else{
      this.notesArray = [];
    }
    
    // 使用inject获取数据，替代localStorage
    
    // let productType = "CSFMU-B";
    this.language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
    // if(this.language=='cn' || this.language=='zh'){
    //   productType = currentData.productType || productType;
    // }
    
    this.selectProductType = currentData.productType || "CSFMU-B";
    this.data = this.getContentByType(this.selectProductType);

    // 初始化额外notes配置
    const notesConfig = this.getNotesConfigMethod();
    this.aditional.note1.checked = notesConfig.additionalNotes.note1;
    this.aditional.note2.checked = notesConfig.additionalNotes.note2;
    this.aditional.note3.checked = notesConfig.additionalNotes.note3;
    this.aditional.specNoteArr = this.data;

    this.isShowNoteChecked = currentData.is_show_note;
    if(currentData.is_show_note == 'true'){
      this.isShowNoteChecked = true;
    }
    this.aditionalNoteCheckedChange();
  },
  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    eventupdateNotesHandler(message){
      console.info("eventupdateNotesHandler111333:")
      this.data = message;
    },
    printCheckboxChange(){
      // 不需要操作
    },
    aditionalNoteCheckedChange(){
      let arrNotes = [];
      // 合并 this.notesArray 和 this.data 的数据
      arrNotes = [...this.notesArray, ...this.data];
      this.setNotesConfigMethod({
        additionalNotes: {
          note1: this.aditional.note1.checked !== undefined ? this.aditional.note1.checked : false,
          note2: this.aditional.note2.checked !== undefined ? this.aditional.note2.checked : false,
          note3: this.aditional.note3.checked !== undefined ? this.aditional.note3.checked : false,
          is_show_note: this.isShowNoteChecked !== undefined ? this.isShowNoteChecked : false,
          cnNote1: this.aditional.cnNote1.checked !== undefined ? this.aditional.cnNote1.checked : false
        },
        specNoteArr: arrNotes
      });
      console.info("aditionalNoteCheckedChange:",this.aditional)
      // const notesConfig = this.getNotesConfigMethod();
      // console.info("notesConfig:",notesConfig)
    },
    
    showENAditionalText(){
      // 使用inject获取数据，替代localStorage
      const currentData = this.getCurrentDataMethod();
      let language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
      let paramsType = this.$route.query.type;
      if(language=='en' && paramsType=="coa"){
        return true;
      }
      return false;
    },
    showCNAditionalText(){
      // 使用inject获取数据，替代localStorage
      const currentData = this.getCurrentDataMethod();
      let language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
      let paramsType = this.$route.query.type;
      // console.info("paramsType:",paramsType)
      // console.info("language:",language)
      if(language=='cn' && paramsType=="coa"){
        return true;
      }
      return false;
    },
    showCNSpecAditionalText(){
      const currentData = this.getCurrentDataMethod();
      let language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
      let paramsType = this.$route.query.type;
      if(language=='cn' && paramsType=="spec"){
        return true;
      }
      return false;
    },
    updateNotes(){
      this.notesArray = this.zdItem.value.split('@$');
    },
    showPrintCheckbox(item) {
      // 更新配置但不使用localStorage
      const notesConfig = this.getNotesConfigMethod();
      notesConfig.additionalNotes.is_show_note = this.isShowNoteChecked;
      // console.info("check :",this.isShowNoteChecked)
      return item.indexOf("（可选打印）") !== -1;
    },
    getContentByType(type) {
      let notes = [];
      // 使用inject获取数据，替代localStorage
      const currentData = this.getCurrentDataMethod();
      let language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
      // console.info("22language:",language)

      if(language=='cn' || language=='zh'){
        notes = defaultData.CNNotesDefaultData;
      }else{
        notes = defaultData.NotesDefaultData;
      }

      // console.info("type222:", currentData.productType )
      type = currentData.productType || type;
      let paramsType = this.$route.query.type;
      if(paramsType=="coa"){
        if(language=='cn' || language=='zh'){
          notes = defaultData.CoaCNNotes;
        }else{
          notes = defaultData.CoaENNotes;
        }
        type = this.coaProductTypeMapping(type);
      }
      
      // console.info("type333:",type)
      for (let data of notes) {
        if (data.type.includes(type)) {
          return data.content;
        }
      }
      return null; // 如果未找到匹配的类型，返回 null
    },
    coaProductTypeMapping(type){
      // 使用inject获取数据，替代localStorage
      const currentData = this.getCurrentDataMethod();
      let language = currentData.language ? currentData.language.toLocaleLowerCase() : 'en';
      
      if(language=='en'){
        if(type=="SHXTO"||type=="EHXTO"){
          return type;
        }else if(type=="Liquid EXT-SH"||type=="Liquid EXT-S"||type=="SDNP-L"){
          return "Liquid"
        }else{
          return "Powder"
        }
      }else{
        let array = ['TY-EHXTO','TY-L','TY-P','TY-SHXTO']
        if(!array.includes(type)) {
          return 'TY-EHXTO'
        }
        return type;
      }
    },
    getDisabled(){
      // 使用inject获取数据，替代localStorage
      if(this.pageStatus == 'Detail'){
        return true;
      }
      return this.zdItem.disabled
    },
    addNotes() {
      let text = this.notes.toString();
      console.info("text111:",text)
      if (text.trim()) {
        this.notesArray.push(text);
        
        // 使用inject的方法添加note
        this.addCustomNoteMethod(text);
        this.zdFormattedValue = this.notesArray;
        this.notes = "";
      }
    },
    deleteNotes(idx){
      if (idx >= 0 && idx < this.notesArray.length) {
        this.notesArray.splice(idx, 1);
        // 使用inject的方法删除note
        this.removeCustomNoteMethod(idx);
      }
    }
  },
};
</script>
